import { Injectable, signal, WritableSignal } from '@angular/core';
import { ESiteContext } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class SiteContextService {
  private readonly context: WritableSignal<ESiteContext> = signal(
    ESiteContext.Shop
  );

  setContext(context: ESiteContext): void {
    this.context.set(context);
  }

  getContext(): ESiteContext {
    return this.context();
  }

  isShopContext(): boolean {
    return this.context() === ESiteContext.Shop;
  }

  isCmsContext(): boolean {
    return this.context() === ESiteContext.Cms;
  }

  toggleContext(): void {
    if (this.isShopContext()) {
      this.setContext(ESiteContext.Cms);
    } else {
      this.setContext(ESiteContext.Shop);
    }
  }
}
